import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=41efcdac&scoped=true&"
import script from "./admin.js?vue&type=script&lang=js&"
export * from "./admin.js?vue&type=script&lang=js&"
import style0 from "./admin.css?vue&type=style&index=0&id=41efcdac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41efcdac",
  null
  
)

export default component.exports